export function refineCourseList( rawCourseList ) {
    if ( !rawCourseList ) { return undefined; }

    // Convert the list of raw courses into their "refined" forms.
    const refinedCourseList = rawCourseList?.edges?.map( ( courseNode ) => {
        return {
            ...courseNode?.node,
            enrollment: courseNode.enrollment,
            learningObjects: courseNode?.node?.learningObjects?.edges.map( ( learningObject ) => ( {
                assignment: learningObject?.assignment,
                ...learningObject?.node,
            } ) ),
            lxp: {
                relatedResourceBrandIds: courseNode.node.brandIds,
                relatedResourceLocaleIds: courseNode.node.localeIds,
                relatedResourceCompanyRelationshipIds: courseNode.node.companyRelationshipIds,
                relatedResourceProductIds: courseNode.node.productIds,
                tags: courseNode.node.tags,
            }
        };
    } );

    return refinedCourseList;
}
